export default __webpack_public_path__ + "static/media/webcurtains2.ef3665bc.png";